var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8333 14.5036C34.75 14.4202 34.7083 14.3369 34.6667 14.2536C34.625 14.1702 34.5833 14.0869 34.5 14.0036L22.8333 2.33691C22.6667 2.17025 22.5 2.00358 22.3333 2.00358C22.1667 1.83691 21.8333 1.83691 21.6667 1.83691H10C7.16667 1.83691 5 4.00358 5 6.83691V33.5036C5 36.3369 7.16667 38.5036 10 38.5036H30C32.8333 38.5036 35 36.3369 35 33.5036V15.1702C35 15.0036 35 14.6702 34.8333 14.5036ZM23.3333 7.50358L29.3333 13.5036H23.3333V7.50358ZM10 35.1702H30C31 35.1702 31.6667 34.5036 31.6667 33.5036V16.8369H21.6667C20.6667 16.8369 20 16.1702 20 15.1702V5.17025H10C9 5.17025 8.33333 5.83691 8.33333 6.83691V33.5036C8.33333 34.5036 9 35.1702 10 35.1702Z",
    fill: "#ACB5BD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8346_59806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 30,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8333 14.5036C34.75 14.4202 34.7083 14.3369 34.6667 14.2536C34.625 14.1702 34.5833 14.0869 34.5 14.0036L22.8333 2.33691C22.6667 2.17025 22.5 2.00358 22.3333 2.00358C22.1667 1.83691 21.8333 1.83691 21.6667 1.83691H10C7.16667 1.83691 5 4.00358 5 6.83691V33.5036C5 36.3369 7.16667 38.5036 10 38.5036H30C32.8333 38.5036 35 36.3369 35 33.5036V15.1702C35 15.0036 35 14.6702 34.8333 14.5036ZM23.3333 7.50358L29.3333 13.5036H23.3333V7.50358ZM10 35.1702H30C31 35.1702 31.6667 34.5036 31.6667 33.5036V16.8369H21.6667C20.6667 16.8369 20 16.1702 20 15.1702V5.17025H10C9 5.17025 8.33333 5.83691 8.33333 6.83691V33.5036C8.33333 34.5036 9 35.1702 10 35.1702Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8346_59806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.169922H40V40.1699H0V0.169922Z",
    fill: "#ACB5BD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/FileUploadIcon.40d1b5722c1a9f314e29bc86b9797997.svg";
export { ForwardRef as ReactComponent };